import { createContext, useContext } from "react";
import type { DashboardNavigation } from "@/api/sidebarEntryAPI";

export type SelectedCustomerContextValue = {
    selectedCustomerId?: number;
    dashboardNavigation?: DashboardNavigation;
    isDashboardNavigationPending: boolean;
};

export const SelectedCustomerContext = createContext<SelectedCustomerContextValue>({
    isDashboardNavigationPending: false,
});

export function useSelectedCustomer() {
    return useContext(SelectedCustomerContext);
}

export function useSelectedCustomerIdParam() {
    const { selectedCustomerId } = useSelectedCustomer();
    return selectedCustomerId ? String(selectedCustomerId) : "";
}
